import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { getBannerByKey, resolveImageUrl } from '../../services/api';

var defaultBnr = require('./../../images/banner/6.jpg');

const bannerCache = {};

const Banner = (props) => {
    const { title, pagename, description, bgimage, pageKey, bannerKey } = props;

    const getTargetKey = () => {
        if (bannerKey) return bannerKey;
        if (pageKey && pageKey !== 'product-detail') return pageKey;
        if (!pagename) return '';
        const parts = pagename.split('/');
        const targetPart = parts.length > 1 ? parts[parts.length - 1] : parts[0];
        return targetPart.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    };

    const targetKey = getTargetKey();

    const resolveBgImage = (url) => {
        if (!url) return '';
        if (typeof url === 'string') {
            if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
            return resolveImageUrl(url);
        }
        return url;
    };

    const [bannerData, setBannerData] = useState(() => {
        if (targetKey && bannerCache[targetKey]) return bannerCache[targetKey];
        try {
            const stored = sessionStorage.getItem(`bs_banner_${targetKey}`);
            if (stored) return JSON.parse(stored);
        } catch (e) {}
        return null;
    });

    const [hasFetched, setHasFetched] = useState(() => !!bannerData);

    useEffect(() => {
        let isMounted = true;
        if (!targetKey) return;

        getBannerByKey(targetKey)
            .then(data => {
                if (isMounted) {
                    if (data) {
                        bannerCache[targetKey] = data;
                        try { sessionStorage.setItem(`bs_banner_${targetKey}`, JSON.stringify(data)); } catch(e) {}
                        setBannerData(data);
                    }
                    setHasFetched(true);
                }
            })
            .catch(() => {
                if (isMounted) setHasFetched(true);
            });

        return () => { isMounted = false; };
    }, [targetKey]);

    const isDetailMode = pageKey === 'product-detail';
    const activeTitle = (isDetailMode ? title : (bannerData && bannerData.title)) || title;
    const activeDesc = (isDetailMode ? description : (bannerData && bannerData.description)) || description;
    
    // Single Banner Image Resolution: Admin DB banner takes absolute precedence.
    // While loading for the first time, old fallback images NEVER render so old images never flash.
    const fetchedBg = bannerData && bannerData.bgImage ? resolveBgImage(bannerData.bgImage) : null;
    const propBg = bgimage ? resolveBgImage(bgimage) : null;
    
    const singleBannerImage = fetchedBg || (hasFetched ? (propBg || defaultBnr) : null);

    return (
        <>
            <div 
                className="sx-bnr-inr overlay-wraper" 
                style={{ 
                    backgroundImage: singleBannerImage ? `url(${singleBannerImage})` : 'none',
                    backgroundColor: '#111111'
                }}
            >
                {/* DARK OVERLAY */}
                <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(15, 15, 15, 0.65)', zIndex: 1 }} />
                
                <div className="container-fluid" style={{ position: 'relative', zIndex: 2, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="sx-bnr-inr-entry text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '100%' }}>
                        <div className="banner-title-outer" style={{ textAlign: 'center', width: '100%' }}>
                            <div className="banner-title-name" style={{ textAlign: 'center' }}>
                                <h2 className="m-tb0 text-white wow fadeInDown" data-wow-duration="0.8s" style={{ fontWeight: '800', letterSpacing: '0.5px', textAlign: 'center' }}>{activeTitle}</h2>
                                {activeDesc && (
                                    <p className="m-t10 text-white-light wow fadeInUp" data-wow-duration="0.9s" data-wow-delay="0.1s" style={{ color: '#e0e0e0', maxWidth: '850px', fontSize: '18.5px', lineHeight: '1.6', margin: '14px auto 0 auto', textAlign: 'center' }}>
                                        {activeDesc}
                                    </p>
                                )}
                            </div>
                        </div>
                        {/* BREADCRUMB ROW */}
                        <div className="m-t15 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <ul className="sx-breadcrumb breadcrumb-style-2" style={{ margin: '12px auto 0 auto', padding: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'nowrap', whiteSpace: 'nowrap', gap: '10px', listStyle: 'none', fontSize: '16.5px' }}>
                                <li><NavLink to="/" style={{ color: '#f03a02', fontWeight: '700', textDecoration: 'none', fontSize: '16.5px' }}>Home</NavLink></li>
                                <li style={{ color: '#aaaaaa', fontWeight: '500', fontSize: '16.5px' }}>/</li>
                                <li style={{ color: '#ffffff', fontWeight: '600', fontSize: '16.5px' }}>{pagename}</li>
                            </ul>
                        </div>
                        {/* BREADCRUMB ROW END */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Banner;